import React from "react";
import { FaWhatsapp, FaArrowRight } from "react-icons/fa6";
import heroImg from "../assets/images/hero-campo.jpeg";
import { site, whatsappUrl } from "../data/site";
import { trackEvent } from "../lib/analytics";

// TODO: confirmar/ajustar estos tres datos antes de publicar — son los números
// que más peso tienen para generar confianza, conviene que sean exactos.
const highlights = [
  { value: "+25", label: "años de experiencia" },
  { brands: ["Rain Bird", "T-L Irrigation"], label: "marcas que representamos" },
  { value: "San Luis", label: "y toda la región" },
];

const Hero = () => {
  return (
    // items-start en mobile: si el contenido es más alto que la pantalla, centrarlo
    // lo metería debajo del navbar fijo. Desde lg sí se centra.
    <section
      id="inicio"
      className="relative isolate flex min-h-[85vh] items-start md:items-center lg:min-h-[92vh]"
    >
      {/* Imagen de fondo. fetchPriority alta: es el elemento LCP de la página. */}
      <img
        src={heroImg}
        alt="Pivote central T-L regando un campo de maíz"
        className="absolute inset-0 -z-20 h-full w-full object-cover"
        fetchpriority="high"
        decoding="async"
      />

      {/* Degradado para que el texto tenga contraste suficiente sobre la foto */}
      <div
        className="absolute inset-0 -z-10 bg-gradient-to-r from-campo-950/95 via-campo-950/75 to-campo-950/20"
        aria-hidden="true"
      />

      <div className="container-site w-full pb-16 pt-[104px] lg:pb-24 lg:pt-[140px]">
        <div className="max-w-2xl animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-campo-100 backdrop-blur-sm">
            <span className="h-1.5 w-1.5 rounded-full bg-campo-400" aria-hidden="true" />
            {site.address.city} · {site.address.region}
          </span>

          <h1 className="mt-6 text-4xl leading-[1.08] text-white sm:text-5xl lg:text-6xl">
            Tecnología y eficiencia en sistemas de riego
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-campo-50/90 sm:text-lg">
            Venta, asesoramiento, diseño e instalación según su necesidad
            específica. Pivotes centrales, alas regadoras,
            riego por aspersión y goteo.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <a
              href="#contacto"
              onClick={() => trackEvent("cta_click", { location: "hero" })}
              className="btn-primary"
            >
              Pedir cotización sin cargo
              <FaArrowRight size={13} aria-hidden="true" />
            </a>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noreferrer"
              onClick={() => trackEvent("contact_click", { method: "whatsapp", location: "hero" })}
              className="btn-outline"
            >
              <FaWhatsapp size={17} aria-hidden="true" />
              Consultar por WhatsApp
            </a>
          </div>

          <dl className="mt-14 grid max-w-lg grid-cols-3 gap-6 border-t border-white/15 pt-7">
            {highlights.map((item) => (
              <div key={item.label}>
                <dt className="sr-only">{item.label}</dt>
                <dd>
                  {item.brands ? (
                    // Dos marcas representadas por igual: mismo tamaño y peso
                    // para ambas, ninguna debe leerse como "la principal".
                    <div className="space-y-0.5">
                      {item.brands.map((brand) => (
                        <span
                          key={brand}
                          className="block font-display text-sm font-extrabold leading-tight text-white sm:text-base"
                        >
                          {brand}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <span className="block font-display text-lg font-extrabold leading-tight text-white sm:text-2xl">
                      {item.value}
                    </span>
                  )}
                  <span className="mt-1 block text-xs leading-snug text-campo-200">
                    {item.label}
                  </span>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};

export default Hero;
